import React, { useState, useEffect } from 'react';
import i18next from 'core/i18n';

import { DialogContent, Select, useFlashMessage, SelectChangeEvent } from '@indigo-ag/component-module';
import { AgFinancingEvaluationType, Phase1 } from '@indigo-ag/schema';

import { EnhancedDialog, ILaborInfo, evaluationTypesOptions, ModalActionButtons } from 'shared';

export interface BackgroundCheckModalLaborProps {
  closeModal: () => void;
  open: boolean;
  laborInfo?: ILaborInfo;
  onSave: (newPhaseInfo: Partial<Phase1>) => Promise<unknown>;
}

export const BackgroundCheckModalLabor: React.FunctionComponent<BackgroundCheckModalLaborProps> = ({
  closeModal,
  open,
  laborInfo,
  onSave
}) => {
  /**
   * State
   */
  const [option, setOption] = useState<AgFinancingEvaluationType | null>(laborInfo?.laborEvaluation || null);

  useEffect(() => {
    setOption(laborInfo?.laborEvaluation || null);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event: SelectChangeEvent<AgFinancingEvaluationType>): void => {
    setOption(event.target.value);
  };

  const { addFlashMessage } = useFlashMessage();

  const updateLaborInfo = () => {
    return onSave({ laborEvaluation: option || undefined }).then(() => {
      addFlashMessage({
        content: `${i18next.t('labor')} ${i18next.t('hasBeenUpdatedSuccessfully')}`,
        title: '',
        variant: 'success'
      });
    });
  };

  return (
    <EnhancedDialog open={open} onClose={closeModal} title={i18next.t('labor')}>
      <DialogContent>
        <Select
          label={i18next.t('evaluation')}
          name="evaluation-options"
          options={evaluationTypesOptions}
          value={option}
          onChange={handleChange}
          placeholder={i18next.t('pleaseSelect')}
        />
      </DialogContent>
      <ModalActionButtons
        closeModal={closeModal}
        disabled={option ? false : true}
        save={updateLaborInfo}
        changeButtonName={i18next.t('saveChanges')}
      />
    </EnhancedDialog>
  );
};
